export interface FactureFournisseurDTO {
    id: number;
    societe: string;
    fournisseur: string
    site: string;
    date: string;
    numero: string;
    dateEcheance: string;
    montantTTC: string;
    montantRestantTTC: string;
    dateDernierReglement: string;
    statut: StatusFacture;
    motif: string;
    commentaires: string;
    causeRejet: string;
    causeLitige: string;
    devise: string;
    typeFacture: TypeFacture;
    numeroBudget: string;
    numeroCommande: string;
    identifiantFacture: string;
}

export enum StatusFacture {
    valide = 'VALIDEE',
    aValider = 'A_VALIDER',
    litige = 'LITIGE',
    rejetee = 'REJETEE',
    payee = 'PAYEE'
}

export enum TypeFacture {
    AVOIR = 'AVOIR',
    FACTURE = 'FACTURE'
}

export enum Operateur {
    superieur = 'SUPERIEUR',
    inferieur = 'INFERIEUR'
}
